const translations = {
    title: 'Service interval configuration'
};

export default translations;
